/* TODO: it is dummy function just to fill object with empty data - it will be later removed */

import { VariantContent } from "src/types/VariantContent";

function getSortOptions(type: VariantContent) {
  switch (type) {
    case `videos`:
      return [
        { title: `Top rated`, value: `rating:desc` },
        { title: `Date added (newest)`, value: `created_at:desc` },
        { title: `Date added (oldest)`, value: `created_at:asc` },
        // { title: `Alphabetically`, value: `alphabetically` },
        // { title: `Author`, value: `author` },
        // { title: `Body part`, value: `body_part` },
        // { title: `Date added`, value: `date_added` },
        // { title: `Difficulty`, value: `difficulty` },
        // { title: `Duration`, value: `duration` },
        // { title: `Focus`, value: `focus` },
        // { title: `Live lesson`, value: `live_lesson` },
        // { title: `Rating`, value: `rating` },
      ];
    case `instructors`:
      return [
        { title: `Alphabetically`, value: `alphabetically` },
        { title: `Country`, value: `country` },
        { title: `Date added`, value: `date_added` },
        { title: `Followers`, value: `followers` },
        { title: `Rating`, value: `rating` },
        { title: `Status`, value: `status` },
      ];
    case `asanas`:
      return [
        { title: `Alphabetically`, value: `alphabetically` },
        { title: `Difficulty`, value: `difficulty` },
        { title: `Focus`, value: `focus` },
        { title: `Duration`, value: `duration` },
        { title: `Style`, value: `style` },
      ];
  }
}

export default getSortOptions;
